var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkbox"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    width: 19,
    height: 19,
    rx: 6,
    fill: "#EAEBED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox1);
export default __webpack_public_path__ + "static/media/checkbox (1).c5567c559d93e937ce219bdafa34f357.svg";
export { ForwardRef as ReactComponent };